<div
  class="skeleton"
  [style]="customStyles()"></div>
